import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Chip,
  Typography,
} from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface CrossSeasonModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  seasonName: string;
  employeeName: string;
}

const CrossSeasonModal: FC<CrossSeasonModalProps> = ({
  open,
  onClose,
  onConfirm,
  seasonName,
  employeeName,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <InfoOutlinedIcon color='warning' />
        {t('crossSeason.modal.title')}
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 2,
            p: 1.5,
            borderRadius: 2,
            bgcolor: 'action.hover',
          }}
        >
          <Typography variant='body2' fontWeight={600} color='text.primary'>
            {employeeName}
          </Typography>
          <Chip
            label={seasonName}
            size='small'
            variant='filled'
            color='warning'
            sx={{ fontSize: '0.7rem', fontWeight: 600 }}
          />
        </Box>

        <DialogContentText>
          {t('crossSeason.modal.description', { employeeName, seasonName })}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color='inherit' variant='outlined'>
          {t('dialog.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          color='warning'
          variant='contained'
          endIcon={<SwapHorizIcon />}
        >
          {t('crossSeason.modal.confirm', { seasonName })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CrossSeasonModal;
